import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-placeholder-card',
    templateUrl: 'placeholder-card.html'
})
export class PlaceholderCardComponent {
    @Input() useAvatarPlaceholder = false
    @Input() opacity = 0.5
}
